import ActiveNumbersTableModals from './ActiveNumbersTableModals';

export default ActiveNumbersTableModals;
